// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list[data-v-d5a8751a] {\n  font-size: 0.88rem;\n  max-width: var(--magic-wallet-mobile-size, 290px);\n  margin: auto;\n  justify-content: space-between;\n}", ""]);
// Exports
module.exports = exports;
